export const LinearProgressMainLayoutActivate = () => ({
    type: 'LinearProgressMainLayoutActivate'
});

export const LinearProgressMainLayoutDeactivate = () => ({
    type: 'LinearProgressMainLayoutDeactivate'
});
